import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import {
  SR_APPLICATION_ASSEMBLY_LINE_STATUS_NOT_STARTED,
  SR_APPLICATION_ASSEMBLY_LINE_STATUS_IN_PROGRESS,
  SR_APPLICATION_ASSEMBLY_LINE_STATUS_NOT_QUALIFIED,
  SR_APPLICATION_ASSEMBLY_LINE_STATUS_QUALIFIED,
} from 'common/applicationAssemblyLineConstants';

import SrBox from 'client/components/SrBox';

import './SrApplicationAssemblyLineContainerBox.less';

const SR_FORM_EDIT_CONTAINER_STATUS_TO_CLASSNAME_MAPPING = {
  [SR_APPLICATION_ASSEMBLY_LINE_STATUS_NOT_STARTED]: 'status-not-started',
  [SR_APPLICATION_ASSEMBLY_LINE_STATUS_QUALIFIED]: 'status-complete',
  [SR_APPLICATION_ASSEMBLY_LINE_STATUS_IN_PROGRESS]: 'status-in-progress',
  [SR_APPLICATION_ASSEMBLY_LINE_STATUS_NOT_QUALIFIED]: 'status-error',
};

const SrApplicationAssemblyLineContainerBox = ({
  children,
  status,
  padding,
}) => {
  return (
    <SrBox
      styleName={classnames(
        'SrApplicationAssemblyLineContainerBox',
        SR_FORM_EDIT_CONTAINER_STATUS_TO_CLASSNAME_MAPPING[status],
      )}
      padding={padding}
    >
      {children}
    </SrBox>
  );
};

SrApplicationAssemblyLineContainerBox.propTypes = {
  children: PropTypes.node,
  status: PropTypes.string,
  padding: PropTypes.string,
};

SrApplicationAssemblyLineContainerBox.defaultProps = {
  status: SR_APPLICATION_ASSEMBLY_LINE_STATUS_NOT_STARTED,
  padding: '16px',
};

SrApplicationAssemblyLineContainerBox.displayName = 'SrApplicationAssemblyLineContainerBox';

export default SrApplicationAssemblyLineContainerBox;
